import { useEffect, useMemo, useState } from 'react';
export const OutOfViewDirections = {
  UP: 'UP',
  DOWN: 'DOWN'
};
export const useIsVisibleOnScreen = (ref, root) => {
  const [elementVisibility, setElementVisibility] = useState({
    outOfViewDirection: undefined,
    isVisible: undefined
  });
  const observer = useMemo(() => new IntersectionObserver(([entry]) => {
    if (entry.rootBounds === null) {
      return;
    }
    if (entry.isIntersecting || entry.boundingClientRect.top === entry.rootBounds.top) {
      setElementVisibility({
        outOfViewDirection: undefined,
        isVisible: true
      });
    } else if (entry.boundingClientRect.top < entry.rootBounds.top) {
      setElementVisibility({
        outOfViewDirection: OutOfViewDirections.UP,
        isVisible: false
      });
    } else {
      setElementVisibility({
        outOfViewDirection: OutOfViewDirections.DOWN,
        isVisible: false
      });
    }
  }, {
    threshold: 1,
    root
  }), [root]);
  useEffect(() => {
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [observer, ref]);
  return elementVisibility;
};